import { http } from 'helpers';

const createGuest = async payload => await http().post(`/createGuest`, payload);
const getGuests = async id =>
  await http().get(`/guestsForService?case_id=${id}`);

export { createGuest, getGuests };
